export const formatPhoneNumber = (phoneNumber) => {
  return `+1${phoneNumber.replace(/\D/g, "")}`;
};
// This function is designed to add the +1 prefix when formatting the phone number.
// It is used after collecting the user's input and before submitting the form.
// The function ensures that the phone number is sent to the backend with the correct prefix.
// This prefix is necessary for compliance with OTP services like Amazon Pinpoint, Twilio, etc.,
// which require the full international format, including the country code, to properly deliver SMS or voice calls.

export function quantifyNumEnding(value) {
  if (value < 1000) {
    return value.toString();
  } else if (value < 1_000_000) {
    // Thousands
    return (value / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  } else if (value < 1_000_000_000) {
    // Millions
    return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (value < 1_000_000_000_000) {
    // Billions
    return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  } else {
    // Trillions
    return (value / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
  }
}
